
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { CheckCircle } from "lucide-react";
import { useCheckoutStore } from "@/stores/checkoutStore";
import { formatPrice } from "@/lib/utils";

interface OrderSummaryProps {
  course: {
    title: string;
    price: number;
    image_url: string;
    instructor?: string; // Make instructor optional
  };
}

const OrderSummary = ({ course }: OrderSummaryProps) => {
  const { discountApplied, discountAmount, finalAmount, originalAmount } = useCheckoutStore();
  
  // Calculate the actual price to display
  const displayPrice = discountApplied ? finalAmount / 100 : course.price;
  const vatAmount = displayPrice * 0.2;
  
  return (
    <Card className="sticky top-24">
      <CardHeader>
        <CardTitle>Tellimuse kokkuvõte</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-start gap-4">
            <div className="rounded-md overflow-hidden w-16 h-16 flex-shrink-0">
              <img 
                src={course.image_url}
                alt={course.title}
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h4 className="font-medium">{course.title}</h4>
              {course.instructor && (
                <p className="text-sm text-gray-500">Koolitaja: {course.instructor}</p>
              )}
              <p className="text-sm text-gray-500">Täielik juurdepääs kursusele</p>
            </div>
          </div>
          
          <Separator />
          
          <div className="border-t pt-4">
            <div className="flex justify-between items-center">
              <span className="text-gray-600">Hind:</span>
              <span className="font-medium">{course.price}€</span>
            </div>
            
            {discountApplied && (
              <div className="flex justify-between items-center mt-2 text-sm text-green-600">
                <span>Allahindlus:</span>
                <span>-{(discountAmount / 100).toFixed(2)}€</span>
              </div>
            )}
            
            <div className="flex justify-between items-center mt-2 text-sm">
              <span>Käibemaks (20%)</span>
              <span>{vatAmount.toFixed(2)}€</span>
            </div>
            
            <div className="flex justify-between items-center mt-2 text-lg">
              <span className="font-semibold">Kokku:</span>
              <span className="font-semibold">{displayPrice.toFixed(2)}€</span>
            </div>
          </div>
        </div>
      </CardContent>
      <CardFooter className="flex flex-col space-y-3 text-sm">
        <div className="flex items-center text-green-600">
          <CheckCircle className="h-4 w-4 mr-2" />
          <span>30-päevane raha tagasi garantii</span>
        </div>
        <div className="flex items-center text-green-600">
          <CheckCircle className="h-4 w-4 mr-2" />
          <span>Eluaegne juurdepääs kursusele</span>
        </div>
      </CardFooter>
    </Card>
  );
};

export default OrderSummary;
